module.exports = __webpack_public_path__ + "static/media/Pan-card-icon.da3e3a8e.png";